<template>
	<div class="case">
		<banner img="../assets/img/bgtop.jpg" title="设备清单" />
		<div class="product-center">
			<el-table :data="caseList" style="width: 100%" border show-header stripe>
				<el-table-column prop="name" :cell-style="{ textAlign: 'center' }" align="center">
					<template slot="header">
					      <h1>设备名称<br/>Machine name</h1>
					</template>
				</el-table-column>
				<el-table-column prop="stroke" :cell-style="{ textAlign: 'center' }" align="center">
					<template slot="header">
					      <h1>行程<br/>Stroke</h1>
					</template>
				</el-table-column>
				<el-table-column prop="qry" :cell-style="{ textAlign: 'center' }" align="center">
					<template slot="header">
					      <h1>数量<br/>Qty</h1>
					</template>
				</el-table-column>
				<el-table-column prop="brand" :cell-style="{ textAlign: 'center' }" align="center">
					<template slot="header">
					      <h1>机器厂家<br/>Brand</h1>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import Banner from "../components/Banner";
	import {
		caseList
	} from "./data/case.js";
	export default {
		components: {
			Banner
		},
		data() {
			return {
				// 所有产品的数据
				caseList: []
			};
		},

		created() {},

		mounted() {
			this.caseList = caseList
		},

		methods: {}
	};
</script>

<style lang="scss" scoped>
	.product-center{
		margin-left: 100px;
		margin-right: 100px;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	.case {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		background-color: #14679f;
	}
</style>
